module.exports = __webpack_public_path__ + "static/media/forward-arrow-dark.c8be3123.svg";